(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
  const OffCanvasMenu = {
    init: function () {
      this.toggle();
      this.submenu();
    },
    toggle: function () {
      const toggleElements = document.querySelectorAll('[data-offcanvas-toggle]');
      toggleElements.forEach((el) => {
        el.addEventListener('click', function (t) {
          t.preventDefault();
          const offcanvas = document.querySelector('.mobile-menu');
          const body = document.body;
          const burger = document.querySelector('.header__burger');
          const minicart = document.querySelector('.minicart');
          const header = document.querySelector('header');

          if (offcanvas.classList.contains('mobile-menu--visible') && body.classList.contains('body-is-locked')) {
            offcanvas.classList.remove('mobile-menu--visible');
            if (burger) burger.classList.remove('header__burger--cross');
            body.classList.remove('body-is-locked');

            if (header && !header.classList.contains('header--sticked')) {
              header.classList.remove('header--filled');
            }

            setTimeout(function () {
              document
                .querySelectorAll('.mobile-menu__content, .mobile-menu__submenu')
                .forEach((el) => (el.scrollTop = 0));
              document
                .querySelectorAll('.mobile-menu__submenu')
                .forEach((el) => el.classList.remove('mobile-menu__submenu--visible'));
              offcanvas.classList.remove('mobile-menu--subexpanded');
              offcanvas.querySelectorAll('[data-drawer]').forEach((el) => el.setAttribute('data-drawer', ''));
            }, 200);
          } else {
            if (minicart) minicart.classList.remove('minicart--visible');

            if (header && header.classList.contains('header--sticked')) {
              offcanvas.classList.add('mobile-menu--visible');
            } else {
              if (header) {
                window.scrollTo({
                  top: header.getBoundingClientRect().top + window.scrollY + 1,
                  behavior: 'smooth',
                });
              }
              setTimeout(function () {
                offcanvas.classList.add('mobile-menu--visible');
              }, 300);
            }
            if (burger) burger.classList.add('header__burger--cross');
            body.classList.add('body-is-locked');
          }
        });
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1200) {
          const offcanvas = document.querySelector('.mobile-menu');
          const body = document.body;
          const burger = document.querySelector('.header__burger');

          if (
            offcanvas &&
            offcanvas.classList.contains('mobile-menu--visible') &&
            body.classList.contains('body-is-locked')
          ) {
            offcanvas.classList.remove('mobile-menu--visible');
            if (burger) burger.classList.remove('header__burger--cross');
            body.classList.remove('body-is-locked');
          }
        }
      });
    },
    submenu: function () {
      const submenuItems = document.querySelectorAll('[data-item-has-submenu]');
      submenuItems.forEach((item) => {
        item.addEventListener('click', function (t) {
          t.preventDefault();
          const target = this.getAttribute('data-item-has-submenu');
          const offcanvas = this.closest('.mobile-menu');
          const targetSubmenu = offcanvas.querySelector(`.mobile-menu__submenu[data-offcanvas-submenu="${target}"]`);

          if (targetSubmenu) {
            offcanvas.classList.add('mobile-menu--subexpanded');
            targetSubmenu.classList.add('mobile-menu__submenu--visible');
            setTimeout(function () {
              const submenus = document.querySelectorAll('.mobile-menu__submenus, .mobile-menu__submenu');
              submenus.forEach((el) => {
                // Simple scroll to top
                el.scrollTop = 0;
              });
            }, 300);
          }
        });
      });

      const backButtons = document.querySelectorAll('[data-offcanvas-submenu-back]');
      backButtons.forEach((btn) => {
        btn.addEventListener('click', function (t) {
          t.preventDefault();
          const parentSubmenu = this.closest('[data-offcanvas-submenu]');
          const target = parentSubmenu.getAttribute('data-offcanvas-submenu');
          const offcanvas = document.querySelector('.mobile-menu');

          if (offcanvas) {
            offcanvas.classList.remove('mobile-menu--subexpanded');
            setTimeout(function () {
              const targetEl = offcanvas.querySelector(`.mobile-menu__submenu[data-offcanvas-submenu="${target}"]`);
              if (targetEl) targetEl.classList.remove('mobile-menu__submenu--visible');
            }, 600);
          }
        });
      });
    },
  };
  OffCanvasMenu.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  var announcementBar = {
    init: function () {
      this.messages();
      this.topbarSetHeight();
      window.addEventListener('resize', this.topbarSetHeight.bind(this));
    },
    messages: function () {
      var items = document.querySelectorAll('.topbar__messages li');
      var total = items.length;

      if (total <= 1) return;

      var currentIndex = 0;
      items.forEach(function (item, index) {
        if (item.classList.contains('active')) {
          currentIndex = index;
        }
      });

      setInterval(function () {
        items[currentIndex].classList.remove('active');
        currentIndex = (currentIndex + 1) % total;
        items[currentIndex].classList.add('active');
      }, 3500);
    },
    topbarSetHeight: function () {
      const container = document.querySelector('.topbar__messages');
      if (container) {
        const items = container.querySelectorAll('li');
        if (items.length > 0) {
          const heights = Array.from(items).map((item) => item.offsetHeight);
          const maxHeight = Math.max(...heights);
          const style = window.getComputedStyle(container);
          const totalHeight = maxHeight + parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
          container.style.height = `${totalHeight}px`;
        }
      }
    },
  };
  announcementBar.init();

  } catch(e) { console.error(e); }
})();
})();
